import RoomOutlinedIcon from '@material-ui/icons/RoomOutlined';

import List from './List';

export default {
  list: List,
  icon: RoomOutlinedIcon,
};
